module.exports = __webpack_public_path__ + "media/images/orbit/loading-56b45911e051c1646d4d3142025c2bde7ce98db38259c207959ac2413db542b5.gif";